import React, { useEffect } from "react";
import { useStateIfMounted } from "use-state-if-mounted";
import mqtt_topics from "../../../mqtt/mqtt_topics";
import "./../../../css/app.css";
import useCheckMobileScreen from "./../readingView/useCheckMobileScreen";

const Checkbox = (props) => {
  const mac = mqtt_topics.choosenmac;
  const [state, setState] = useStateIfMounted({
    value: 0,
    title: props.title, //"Normal UI"
    disabled: false, //if returned value == na set to false
    progress: false,
    acc: props.acc,
  });
  const target_live_reading_topic =
    mqtt_topics.fixed_topic_part +
    mac +
    "/" +
    props.category +
    "/" +
    props.subcategory +
    "/" +
    props.title;

  function listenforlivedata() {
    props.mqttClient.subscribe(target_live_reading_topic);
    props.mqttClient.on("message", handleMqttMessage);
  }

  function handleMqttMessage(topic, message) {
    if (topic == target_live_reading_topic) {
      try {
        // message is Buffer
        message = JSON.parse(message.toString());
        if (message.value.toLowerCase().toString() == "nv") {
          setState({
            ...state,
            disabled: true,
            progress: false,
          });
        } else {
          setState({
            ...state,
            value: message.value == undefined ? 0 : message.value,
            disabled: false,
            progress: false,
          });
        }
      } catch (error) {
        //console.log(message);
      }
    }
  }

  useEffect(() => {
    listenforlivedata();
  }, []);

  //when componenet unmount
  useEffect(
    () => () => {
      props.mqttClient.unsubscribe(target_live_reading_topic);
      props.mqttClient.removeListener("message", handleMqttMessage);
    },
    []
  );

  function setparameter(val) {
    if (!mqtt_topics.busy_Requesting_Data) {
      requestdata(val);
    } else {
      setTimeout(function () {
        requestdata(val);
      }, mqtt_topics.timeouttotrytorequestmqttdata); //wait 1 seconds
    }
  }

  function requestdata(val) {
    mqtt_topics.busy_Requesting_Data = true;
    props.mqttClient.publish(
      mqtt_topics.fixed_topic_part + mac + mqtt_topics.request_topic,
      JSON.stringify({
        param: props.category + "/" + props.subcategory + "/" + props.title,
        value: val.toString(),
      })
    );
    mqtt_topics.busy_Requesting_Data = false;
  }

  //className="form-check-input" className="form-check-label"
  return (
    <div
      className="grid-item "
      style={{
        display: state.disabled ? "none" : "block",
        paddingTop: useCheckMobileScreen() ? "5px" : "2px",
      }}
    >
      <div
        className="custom-control custom-switch"
        style={{ display: state.progress ? "none" : "block" }}
      >
        <input
          type="checkbox"
          className="custom-control-input"
          id={props.category + "_" + props.subcategory + "_" + props.title}
          disabled={!state.acc}
          onChange={() => {
            setparameter(state.value > 0 ? 0 : 1);
            setState({
              ...state,
              value: state.value > 0 ? 0 : 1,
              progress: true,
            });
          }}
          checked={state.value > 0}
        />

        <label
          className="custom-control-label"
          htmlFor={props.category + "_" + props.subcategory + "_" + props.title}
        >
          {state.title}
        </label>
      </div>
      <div
        className="spinner-border text-primary"
        style={{ display: state.progress ? "block" : "none" }}
      ></div>
    </div>
  );
};
export default Checkbox;
